import request from '@/utils/request'
const shop = {
  state: {
    shop_display_name: '',
    is_agency_enabled: 0,
    shop_custom_host: '',
    shop_domain_prefix: '',
    is_coupon_enabled: 0,
    mobile_url: '',
    shop_pc_url: '',
    ui_template_id: null,
    open_shop_first: {},
    open_shop_step_info: {},
    my_pay_api_key: null,
    my_pay_mid: null,
    warehouses: [],
    // 仓库信息
    brands: [],
    // 品牌分类
    discountPlans: [],
    // 折扣信息
    categories: []
    // 商品分类
  },
  actions: {
    SetShopBasic({ commit, state }) {
      return new Promise((resolve, reject) => {
        request
          .get('basic')
          .then(response => {
            var is_agency_enabled = response.data.is_agency_enabled
            commit('SET_IS_AGENCY_ENABLED', is_agency_enabled)
            let mobile_url = ''

            var shop_domain_prefix = ''
            if (response.data.shop_domain_prefix) {
              shop_domain_prefix = response.data.shop_domain_prefix
              mobile_url =
                process.env.VUE_APP_MOBILE_URL +
                response.data.shop_domain_prefix
            }
            commit('SET_SHOP_DOMAIN_PREFIX', shop_domain_prefix)
            var shop_custom_host = ''
            if (response.data.shop_custom_host) {
              shop_custom_host = response.data.shop_custom_host
              mobile_url = 'http://' + response.data.shop_custom_host
            }
            commit('SET_SHOP_CUSTOM_HOST', shop_custom_host)

            commit('SET_MOBILE_URL', mobile_url)

            var is_coupon_enabled = response.data.is_coupon_enabled
            commit('SET_IS_COUPON_ENABLED', is_coupon_enabled)

            var shop_pc_url = response.data.shop_pc_url
            commit('SET_PC_URL', shop_pc_url)

            var display_shop_name = response.data.display_shop_name
            commit('SET_DISPLAY_SHOP_NAME', display_shop_name)

            var ui_template_id = response.data.configs.ui_template_id
            commit('SET_UI_TEMPLATE', ui_template_id)
            if (response.data.warehouses) {
              commit('SET_WAREHOUSES', response.data.warehouses)
            }
            if (response.data.brands) {
              commit('SET_BRANDS', response.data.brands)
            }
            if (response.data.categories) {
              commit('SET_CATEGORIES', response.data.categories)
            }
            if (response.data.discountPlans) {
              commit('SET_DISCOUNTPLANS', response.data.discountPlans)
            }
            if (response.data.my_pay_mid) {
              commit('SET_MYPAY_MID', response.data.my_pay_mid)
            }
            if (response.data.my_pay_api_key) {
              commit('SET_MYPAY_API', response.data.my_pay_api_key)
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    SetShopThemeId({ commit, state }) {
      console.log('SetShopThemeId')
      return new Promise((resolve, reject) => {
        request.get('basic')
          .then((res) => {
            if (res.status === 0) {
              var ui_template_id = res.data.configs.ui_template_id
              commit('SET_UI_TEMPLATE', ui_template_id)
            }
          })
      })
    },
    SetOpenShopInfo({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('progress/check/shop/first').then(res => {
          commit('SET_OPEN_SHOP_FIRST', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetOpenShopStepInfo({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('progress/step/status').then(res => {
          commit('SET_OPEN_SHOP_STEP_INFO', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  },

  mutations: {
    SET_OPEN_SHOP_FIRST: (state, data) => {
      state.open_shop_first = data
    },
    SET_OPEN_SHOP_STEP_INFO: (state, data) => {
      state.open_shop_step_info = data
    },
    SET_DISPLAY_SHOP_NAME: (state, data) => {
      state.display_shop_name = data
    },
    SET_IS_AGENCY_ENABLED: (state, data) => {
      state.is_agency_enabled = data
    },
    SET_SHOP_CUSTOM_HOST: (state, data) => {
      state.shop_custom_host = data
    },
    SET_SHOP_DOMAIN_PREFIX: (state, data) => {
      state.shop_domain_prefix = data
    },
    SET_IS_COUPON_ENABLED: (state, data) => {
      state.is_coupon_enabled = data
    },
    SET_MOBILE_URL: (state, data) => {
      state.mobile_url = data
    },
    SET_PC_URL: (state, data) => {
      state.shop_pc_url = data
    },
    SET_UI_TEMPLATE: (state, data) => {
      state.ui_template_id = data
    },
    SET_WAREHOUSES: (state, data) => {
      state.warehouses = data
    },
    SET_BRANDS: (state, data) => {
      state.brands = data
    },
    SET_CATEGORIES: (state, data) => {
      state.categories = data
    },
    SET_DISCOUNTPLANS: (state, data) => {
      state.discountPlans = data
    },
    SET_MYPAY_API: (state, data) => {
      state.my_pay_api_key = data
    },
    SET_MYPAY_MID: (state, data) => {
      state.my_pay_mid = data
    }
  }
}

export default shop
